import accountSvg from '~/shared/assets/icons/account.svg?raw';
import clusterSvg from '~/shared/assets/icons/cluster.svg?raw';
import instanceSvg from '~/shared/assets/icons/instance.svg?raw';
import nodeSvg from '~/shared/assets/icons/node.svg?raw';
import regionSvg from '~/shared/assets/icons/region.svg?raw';
import tagSvg from '~/shared/assets/icons/tag.svg?raw';
import unattachedSvg from '~/shared/assets/icons/unattached.svg?raw';
import volumeSvg from '~/shared/assets/icons/volume.svg?raw';

const ENTITY_ICON_RAW: Record<string, string> = {
  account: accountSvg,
  cluster: clusterSvg,
  nodeGroup: nodeSvg,
  instance: instanceSvg,
  ec2: instanceSvg,
  unattached: unattachedSvg,
  region: regionSvg,
  tag: tagSvg,
  volume: volumeSvg,
};

/** Remap mask/clip IDs so multiple inline SVGs in one document do not collide. */
function uniquifySvgIds(raw: string, suffix: string): string {
  const idRegex = /\bid="([^"]+)"/g;
  const ids = new Set<string>();
  let match: RegExpExecArray | null;
  while ((match = idRegex.exec(raw)) !== null) {
    ids.add(match[1]);
  }
  if (!ids.size) return raw;

  let result = raw;
  const idMap = new Map<string, string>();
  ids.forEach((id) => {
    const nextId = `${id}${suffix}`;
    idMap.set(id, nextId);
    result = result.replaceAll(`id="${id}"`, `id="${nextId}"`);
  });
  idMap.forEach((nextId, id) => {
    result = result.replaceAll(`url(#${id})`, `url(#${nextId})`);
  });
  return result;
}

function toChipSvg(raw: string, type: string): string {
  const sized = raw
    .replace('<svg ', '<svg aria-hidden="true" ')
    .replace(/width="20"/, 'width="14"')
    .replace(/height="20"/, 'height="14"');
  return uniquifySvgIds(sized, `-chip-${type}`);
}

const CHIP_ENTITY_ICON_SVG = Object.fromEntries(
  Object.entries(ENTITY_ICON_RAW).map(([type, raw]) => [type, toChipSvg(raw, type)])
);

export function chipEntityIconSvg(type: string): string {
  return CHIP_ENTITY_ICON_SVG[type] ?? '';
}
